<template>
    <v-simple-table dense>
        <thead>
            <tr>
                <th>{{$t("warehouse")}}</th>
                <th>{{$t("on_hand_quantity")}}</th>
                <th>{{$t("total_value")}}</th>
            </tr>
        </thead>
        <tbody>
            <tr v-if="data.length == 0">
                <td colspan="3" class="text-center">{{$t("no_result")}}</td>
            </tr>
            <tr v-for="(item, index) in data" :key="index" >
                <td>{{ item.warehouse }}</td>
                <td>{{ formatNumber(item.quantity, round) }}</td>
                <td>{{ formatNumber(item.value, round) }}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr class="font-weight-bold">
                <td>{{$t("total")}}</td>
                <td>{{ formatNumber(getTotal(data, "quantity"), round) }}</td>
                <td>{{ formatNumber(getTotal(data, "value"), round) }}</td>
            </tr>
        </tfoot>
    </v-simple-table>
</template>

<script>
import { getByItemReport} from './../../services/stock/reports'
import { getTotal } from '../../utils/accounting';
import { formatNumber } from 'accounting';

export default {
    
    data() {
        return {
            data: [],
            errors: [],
            loading: false,
            dirty: false,
            round: 2
        }
    },
    watch: {
        loading(value) {
            this.$emit("loading", value);
        }
    },
    props: {
        itemId: null,
    },
    methods: {
        getTotal,
        formatNumber,
        async submit() {
            try {
                this.clearErrors();
                this.loading = true;
                let resp = await getByItemReport({item_id: this.itemId});
                this.data = resp.data;
                this.loading = false;
                this.dirty = true;
            } catch (error) {
                let message = error.response ? error.response.data.message : error;
                this.errors.push(message);
                this.loading = false;
            }
        },
        clearErrors () {
            this.errors = [];
        }
    }
}
</script>

<style>

</style>